// Autogenerated file
export const outputIndexesPeriodTypesEnum = {
    LastMonth: "LastMonth",
    LastThreeMonths: "LastThreeMonths",
    LastSixMonths: "LastSixMonths",
    FromStartOfTheYear: "FromStartOfTheYear",
    LastYear: "LastYear",
    LastThreeYears: "LastThreeYears",
    AllTime: "AllTime",
};
export const outputIndexesPeriodTypes = [
    { label: "Последний месяц", value: "LastMonth" },
    { label: "Последние 3 месяца", value: "LastThreeMonths" },
    { label: "Последние 6 месяцев", value: "LastSixMonths" },
    { label: "C начала текущего года", value: "FromStartOfTheYear" },
    { label: "За 1 год", value: "LastYear" },
    { label: "За 3 года", value: "LastThreeYears" },
    { label: "За все время", value: "AllTime" },
];
